export const setToggleContentListener = (sections) => {
  const links = document.querySelectorAll('custom-sub-navbar a');

  links.forEach(link => {
    link.addEventListener('click', function () {
      // Remove any fade-out classes
      sections.forEach(section => {
        if(!section.classList.contains('fade-out')) return

        section.classList.remove('fade-out');
      });

      // Hide all sections and remove the 'active' class
      sections.forEach(section => {
        if(!section.classList.contains('active')) return;

        section.classList.remove('active', 'fade-in');
        section.classList.add('fade-out');
      });

      // Show the corresponding section and add the 'active' class after a delay
      setTimeout(() => {
        const targetId = this.getAttribute('data-target');
        const targetSection = document.getElementById(targetId);
        targetSection.classList.add('active', 'fade-in');
      }, 305);
    });
  });
}